/** Query `type` for GET /chats/ — P2P list */
export const CHAT_API_TYPE_DIRECT = 'direct'

/** Query `type` for GET /chats/ — group list */
export const CHAT_API_TYPE_GROUP = 'group'

export const CONVERSATION_TYPE_KEYS = {
  ALL: '',
  HA_WITH_SA: 'ha_with_sa',
  CLINICIAN_WITH_SA: 'clinician_with_sa',
  CLINICIAN_WITH_HA: 'clinician_with_ha',
}

export const SA_FILTER_OPTIONS = [
  { label: 'All', value: CONVERSATION_TYPE_KEYS.ALL },
  { label: 'Health Agencies', value: CONVERSATION_TYPE_KEYS.HA_WITH_SA },
  { label: 'Clinicians', value: CONVERSATION_TYPE_KEYS.CLINICIAN_WITH_SA },
]

export const HA_FILTER_OPTIONS = [
  { label: 'All', value: CONVERSATION_TYPE_KEYS.ALL },
  { label: 'Staff Agencies', value: CONVERSATION_TYPE_KEYS.HA_WITH_SA },
  { label: 'Clinicians', value: CONVERSATION_TYPE_KEYS.CLINICIAN_WITH_HA },
]

/** GET /chats/ when `type=group` — episode of care filter */
export const GROUP_EPISODE_STATUS_KEYS = {
  ALL: '',
  ACTIVE: 'active',
  EXPIRED: 'expired',
}

export const GROUP_EPISODE_STATUS_OPTIONS = [
  { label: 'All', value: GROUP_EPISODE_STATUS_KEYS.ALL },
  { label: 'Active EoC', value: GROUP_EPISODE_STATUS_KEYS.ACTIVE },
  { label: 'Expired EoC', value: GROUP_EPISODE_STATUS_KEYS.EXPIRED },
]
